import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {httpGetUserGroups} from '@/features/user-groups/http/user-groups.http.ts'
import {captureException} from '@sentry/react'
import {UserGroup} from '@/features/user-groups/types.ts'
import {z} from 'zod'
import {PaginationResponse, ResponseType} from '@/types'

// Paginated response shape
const ResponseShape = z.object({
    data: z.array(UserGroup),
    meta: PaginationResponse
})
type ResponseShape = z.infer<typeof ResponseShape>

export const useGetUserGroups = (
    params: {search?: string} = {},
    options?: Omit<UseQueryOptions<ResponseShape>, 'queryKey' | 'queryFn'>
) => {
    return useQuery({
        queryKey: [QUERY_KEYS.USER_GROUPS, params],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetUserGroups({
                    params: {
                        ...params,
                        responseType: 'small' as ResponseType
                    }
                }),
                onZodError: captureException,
                responseShape: ResponseShape
            }),
        ...options
    })
}
